<template>
  <div class="login-chips" role="list" aria-label="Platform metrics">
    <div
      v-for="metric in metrics"
      :key="metric.key"
      class="login-chip"
      role="listitem"
    >
      <v-icon :icon="metric.icon" class="login-chip__icon" />
      <span class="login-chip__value">{{ metric.value }}</span>
      <span class="login-chip__label">{{ metric.label }}</span>
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: 'LoginMetricChips' })

const metrics = [
  { key: 'answered', value: '100%', label: 'Answered', icon: 'mdi-phone-check' },
  { key: 'active', value: '24/7', label: 'Active', icon: 'mdi-clock-outline' },
  { key: 'response', value: '3 sec', label: 'Response', icon: 'mdi-lightning-bolt' },
  { key: 'leads', value: '0', label: 'Missed', icon: 'mdi-account-check-outline' },
]
</script>
